import { Analytics } from "./types";
import LinkedInTag from "react-linkedin-insight";

function LinkedInAnalytics(): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: () => {},
    screen: () => {
      LinkedInTag.track();
    },
    ecommerceEvent: () => {},
    event: () => {},
  };
}

export class LinkedInSourceProvider {
  initialize(client: LinkedInClient): Analytics {
    LinkedInTag.init(client.linkedInTrackingId, "dc");
    if (client.linkedInConversionId) {
      LinkedInTag.track(client.linkedInConversionId);
    }
    return LinkedInAnalytics();
  }
}

interface LinkedInTrackingOptions {
  linkedInTrackingId: string;
  linkedInConversionId?: string;
  sendPageView?: boolean;
}

export interface LinkedInClient extends LinkedInTrackingOptions {
  provider: "linkedin";
}

export function makeLinkedInClient(
  trackingId: string,
  conversionId?: string,
  options?: LinkedInTrackingOptions
): LinkedInClient {
  return {
    provider: "linkedin",
    linkedInTrackingId: trackingId,
    linkedInConversionId: conversionId,
    sendPageView: options?.sendPageView ?? true,
  };
}
